import { render, staticRenderFns } from "./taskDetail.vue?vue&type=template&id=c5fc5cd2&scoped=true&"
import script from "./taskDetail.vue?vue&type=script&lang=js&"
export * from "./taskDetail.vue?vue&type=script&lang=js&"
import style0 from "./taskDetail.vue?vue&type=style&index=0&id=c5fc5cd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fc5cd2",
  null
  
)

export default component.exports